import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MalidCard from './MalidCard';

class OrdabankiView extends Component {
	render() {
		return (
			<MalidCard title={window.l('ordabanki_title')}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)}
				frontPage={this.props.frontPage}
				aboutText={window.l('ordabanki_about')}
				database="ordabanki">
				{
					this.props.data && this.props.data.map(function(item, index) {
						return <React.Fragment>
							{
								index > 0 && <hr className="divider"/>
							}
							<p className="card-text" key={index}>
								<a href={'http://ordabanki.hi.is/wordbank/terminfo?idTerm='+item.id_hugtak}><strong>{item.hugtak_ord}</strong></a><br/>
								[{item.ordasafn}]{
									item.sersvid &&
									<React.Fragment> (<em>{item.sersvid}</em>)</React.Fragment>
								}<br/>
								{
									item.samheiti &&
									<React.Fragment>
										<strong>samheiti</strong> {
											item.samheiti.map(function(samheiti, sIndex) {
												return <React.Fragment key={sIndex}>{
													sIndex > 0 &&
													<React.Fragment>, </React.Fragment>
												}{samheiti.sh}</React.Fragment>
											})
										}<br/>
									</React.Fragment>
								}
								{
									item.skilgreining &&
									<React.Fragment>[skilgreining] <span dangerouslySetInnerHTML={{__html: item.skilgreining}} /><br/></React.Fragment>
								}
								{
									item.skyring &&
									<React.Fragment>[skýring] <span dangerouslySetInnerHTML={{__html: item.skyring}} /><br/></React.Fragment>
								}
								{
									item.thyding && item.thyding.map(function(thyding, tIndex) {
										return <React.Fragment key={tIndex}>[{thyding.tungumal}] <strong>{thyding.erlent_ord}</strong><br/></React.Fragment>
									})
								}

							</p>
						</React.Fragment>
					}.bind(this))
				}
			</MalidCard>
		);
	}
}

export default OrdabankiView;



// WEBPACK FOOTER //
// ./src/components/OrdabankiView.js